import { createAction } from 'redux-act';

export const fetchSwappedCard = createAction<object>('Fetch Swapped Cards');
export const fetchSwappedCardSuccess = createAction<[]>('Fetch Swapped Cards success');
export const fetchSwappedCardFailure = createAction('Fetch Swapped Cards Error');
// export const saveSwappedProfile = createAction<any>('save swapped profile');
